import React from 'react';
import { Link } from 'react-router-dom';

import { Lazy } from 'src/components/lazy';

import * as S from './styles';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

type Props = {
  className?: string;
  imageUrl?: string | null;
  pathName: string;
  preamble: string;
  title: string;
  linkText?: string;
};

const FeaturedArticle = ({
  className,
  imageUrl,
  pathName,
  preamble,
  title,
  linkText,
}: Props) => {
  const renderArticleLink = () => {
    if (!linkText) {
      return null;
    }

    return (
      <S.ArticleLink
        container="a"
        containerProps={{ href: pathName }}
        onClick={() =>
          trackInternalNavigationClick({
            scope: InternalNavigationScope.ARTICLE_READ_MORE,
            nextPage: pathName,
          })
        }
      >
        {linkText}
      </S.ArticleLink>
    );
  };

  return (
    <S.FeaturedArticle className={className}>
      {imageUrl && (
        <S.ImageWrapper>
          <Lazy loadOnIdle>
            <Link
              to={pathName}
              onClick={() => {
                trackInternalNavigationClick({
                  scope: InternalNavigationScope.ARTICLE_CONTENT_CARD,
                  nextPage: pathName,
                });
              }}
            >
              <img src={imageUrl} alt="" />
            </Link>
          </Lazy>
        </S.ImageWrapper>
      )}
      <S.TextContainer>
        <h3>
          <Link to={pathName}>{title}</Link>
        </h3>

        <Link
          to={pathName}
          onClick={() =>
            trackInternalNavigationClick({
              scope: InternalNavigationScope.ARTICLE_READ_MORE,
              nextPage: pathName,
            })
          }
        >
          <p>{preamble}</p>
        </Link>

        {renderArticleLink()}
      </S.TextContainer>
    </S.FeaturedArticle>
  );
};

export default FeaturedArticle;
